export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out on a per block basis. Users can withdraw or compound at any time.`,
  },
  {
    question: `What is the inflation?`,
    answer: `Stakers earn deflationary DVPN from the network and service fees from the hub. The genesis inflation is set at 49% and will decrease by 6% every 6 months until the annualized inflation reaches 13%. Inflation will then proceed in a constant decay model (on a per block basis) approaching 0.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 28 days unbonding period when unstaking DVPN from the network. Users will not earn rewards and will be susceptible to slashing during unbonding.`,
  },
  {
    question: `How to restake?`,
    answer: `Users may manually withdraw rewards and restake to compound their returns. Enabling auto-compound via REstake by Eco Stake is also an available option.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Staking risks do apply including slashing involved for downtime and double signing.`,
  },
];
